import { ChevronRight } from "lucide-react"
import { type ReactNode, useState } from "react"
import { cn } from "@/shared/lib/utils"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./collapsible"

/**
 * Раскрывающийся блок вместо `<details>`: высота плавно растёт и сворачивается,
 * стрелка поворачивается. `variant="card"` для отдельной карточки на странице,
 * `inline` для строки внутри диалога или панели.
 */
export function Disclosure({
	title,
	children,
	defaultOpen = false,
	variant = "inline",
	className,
	titleClassName,
}: {
	title: ReactNode
	children: ReactNode
	defaultOpen?: boolean
	variant?: "card" | "inline"
	className?: string
	titleClassName?: string
}) {
	const [open, setOpen] = useState(defaultOpen)
	const card = variant === "card"
	return (
		<Collapsible
			open={open}
			onOpenChange={setOpen}
			className={cn(card && "rounded-2xl border border-border bg-card", className)}
		>
			<CollapsibleTrigger
				className={cn(
					"group flex w-full cursor-pointer items-center gap-2 text-left transition-colors",
					card ? "px-5 py-4 font-medium" : "text-sm text-muted-foreground hover:text-foreground",
					titleClassName,
				)}
			>
				<ChevronRight
					aria-hidden
					className="size-4 shrink-0 text-muted-foreground transition-transform duration-200 group-data-[state=open]:rotate-90"
				/>
				<span className="min-w-0 flex-1">{title}</span>
			</CollapsibleTrigger>
			<CollapsibleContent>
				<div className={card ? "px-5 pb-5" : "pt-2"}>{children}</div>
			</CollapsibleContent>
		</Collapsible>
	)
}
